const truncateTextBlock = (text, charactersNumber) => {
    if(text?.length > charactersNumber){
        const slicedText = text?.slice(0,charactersNumber)
        return `${slicedText}...`
    }

    return text
}

export default truncateTextBlock